
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';

import Routes from '../common/client/components/Routes';

import { PAGE_USEK_INPUT, PAGE_USEK_ATTRS, PAGE_PRICELIST, PAGE_CALC } from './pagesDefinition';
import App from './App';
import CalculationPage from './calculationPage/CalculationPage.state';
import LandingPage from './landingPage/LandingPage.state';
import ProjectBasePage from './ProjectBasePage';
import SelectPricelistPage from './selectPricelistPage/SelectPricelistPage.state';
import UsekAttrsPage from './usekAttrsPage/UsekAttrsPage.state';
import UsekInputPage from './usekInputPage/UsekInputPage.state';

const routes = [
    {
        component: App,
        routes: [{
            path: '/',
            exact: true,
            component: LandingPage
        }, {
            component: ProjectBasePage,
            routes: [{
                path: PAGE_USEK_INPUT.pathname,
                component: UsekInputPage
            }, {
                path: PAGE_USEK_ATTRS.pathname,
                component: UsekAttrsPage
            }, {
                path: PAGE_PRICELIST.pathname,
                component: SelectPricelistPage
            }, {
                path: PAGE_CALC.pathname,
                component: CalculationPage
            }]
        }]
    }
];

const AppRouter = () => {
    return (
        <Router>
            <Routes routes={routes} />
        </Router>
    );
}

export default AppRouter;
